export class AuthError extends Error {
  content: ErrorContent;
  constructor(content: ErrorContent) {
    super(content.code);
    this.content = content;
  }
}

type ErrorContent =
  | {
      code: 'user-not-found';
    }
  | {
      code: 'unauthorized';
    };
